import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { LOCAL_STORAGE } from "../constants/local-storage.constants";
import {
	Currency,
	CurrencySymbol,
	PaymentGateways,
} from "../enums/payment-gateways.enum";
import { GET_GATEWAY_FROM_SETTLEMENT_ACCOUNT } from "../queries/payment-gateway-queries";
import { LocalStorageService } from "./local-storage.service";
import { SessionStorageService } from "./session-storage.service";
import { SESSION_STORAGE } from "../constants/session-storage.constants";

@Injectable({
	providedIn: "root",
})
export class PaymentGatewaysService {
	constructor(private apollo: Apollo) {}

	getPaymentGateway() {
		return this.apollo
			.watchQuery({
				query: GET_GATEWAY_FROM_SETTLEMENT_ACCOUNT,
				variables: {
					businessId: SessionStorageService.getValue(SESSION_STORAGE.BUSINESSID),
					merchantId: SessionStorageService.getValue(SESSION_STORAGE.MERCHANT_ID),
				},
			})
			.valueChanges.subscribe((res: any) => {
				const settlementAccounts = res?.data?.GetSettlementAccountsType ?? [];
				if (!settlementAccounts.length) {
					return;
				}

				const account = settlementAccounts[0];
				if (!account) {
					return;
				}

				const gateway: PaymentGateways = account.accountType;
				console.log("gateway", gateway);

				switch (gateway) {
					case PaymentGateways.STRIPE:
						LocalStorageService.setValue(
							LOCAL_STORAGE.CURRENCY,
							Currency.AMERICAN_DOLLAR,
						);
						LocalStorageService.setValue(
							LOCAL_STORAGE.CURRENCY_SYMBOL,
							CurrencySymbol.AMERICAN_DOLLAR,
						);
						LocalStorageService.setValue(
							LOCAL_STORAGE.PAYMENT_GATEWAY,
							gateway,
						);
						break;
					case PaymentGateways.RAZORPAY:
						LocalStorageService.setValue(
							LOCAL_STORAGE.CURRENCY,
							Currency.INDIAN_RUPEES,
						);
						LocalStorageService.setValue(
							LOCAL_STORAGE.CURRENCY_SYMBOL,
							CurrencySymbol.INDIAN_RUPEES,
						);
						LocalStorageService.setValue(
							LOCAL_STORAGE.PAYMENT_GATEWAY,
							gateway,
						);
						const fixedFee = account.fixedFee;
						const simpayXFee = account.simPayXFee;

						console.log(fixedFee,simpayXFee);
						LocalStorageService.setValue(LOCAL_STORAGE.FIXED_FEE,fixedFee);
						LocalStorageService.setValue(LOCAL_STORAGE.SIMPAYX_FEE,simpayXFee);
						break;
					default:
						break;
				}
			});
	}
}
